module.exports = __webpack_public_path__ + "img/stock-img.cec4f6ac.webp";